// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__12lZl","right":"Footer_right__1ZUBR","buttons":"Footer_buttons__1ZCLb"};